import React, {createRef, useContext, useRef, useState} from "react";
import {createPopper} from "@popperjs/core";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";
import {closeSession} from "./../../api/auth.service";
import {UseLoader} from "../../hooks/useLoader";
import { Toast } from 'primereact/toast';
import {AppContext} from "../../context/appContext";
import {types} from "../../shared/types/types";
const UserDropdown = () => {
    // dropdown props
    const toast = useRef(null);
    const [handleLoader] = UseLoader();
    const { dispatch} = useContext(AppContext);
    const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
    const btnDropdownRef = createRef();
    const popoverDropdownRef = createRef();
    const openDropdownPopover = () => {
        createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
            placement: "bottom",
        });
        setDropdownPopoverShow(true);
    };
    const closeDropdownPopover = () => {
        setDropdownPopoverShow(false);
    };

    const cerrarSesion = async () => {
        try {
            handleLoader(true);
            const response = await closeSession();
            handleLoader(false);
            const resposeData = await response.data;

            if (resposeData.estado !== 200) {
                toast.current?.show({severity:'danger', summary: 'Alerta', detail: resposeData.mensaje, life: 3000});
                return;
            }
            const action = {
                type: types.logout
            }
            toast.current?.show({severity:'success', summary: 'Hasta la próxima', detail: resposeData.mensaje, life: 2000});
            setTimeout(() => {
                dispatch(action);
            }, 2000)

        }catch (e) {
            handleLoader(false);
        }
    }
    return (
        <>
            <Toast ref={toast} />
            <a
                className="text-blueGray-500 block"
                href="#pablo"
                ref={btnDropdownRef}
                onClick={(e) => {
                    e.preventDefault();
                    dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
                }}
            >
                <div className="items-center flex">
          <span
              className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            <img
                alt="..."
                className="w-full rounded-full align-middle border-none shadow-lg"
                src={"/img/toa.png"}
            />
          </span>
                </div>
            </a>
            <div
                ref={popoverDropdownRef}
                className={
                    (dropdownPopoverShow ? "block " : "hidden ") +
                    "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
                }
            >

                <Link
                    className={
                        "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                    }
                    to="/profile"
                >
                    Perfil

                </Link>

                <div className="h-0 my-2 border border-solid border-blueGray-100"/>
                <button
                    className={
                        "text-left focus:outline-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                    }
                    onClick={async (e) =>  {
                        e.preventDefault();
                        await cerrarSesion();
                    }}
                >
                 Cerrar sesión
                </button>
            </div>
        </>
    );
};

export default UserDropdown;
